import { gql } from '@grandvisionhq/graphql';
import { checkoutMutationResult } from '../fragments/checkout-mutation-result.js';
import { unknownUpdateCartFailure } from '../fragments/cart-mutation-failures.js';
import '../fragments/recreate-ordered-checkout-failure.js';
import '../fragments/recreate-ordered-checkout-result.js';
import '../fragments/paypal-payment.js';
import '../fragments/saved-user-details.js';

const SET_SERVICE_STORE = gql`
  mutation SetServiceStore($storeInput: CheckoutServiceStoreInput!) {
    setServiceStore(storeInput: $storeInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;

export { SET_SERVICE_STORE };
//# sourceMappingURL=set-service-store.js.map
